import React, { useEffect, useState } from "react";
import Layouts from "../../Layouts";
import priorityIcon from "../../../Assets/Images/Rpm/Red.svg";
import priorityIcon1 from "../../../Assets/Images/Rpm/Yellow.svg";
import priorityIcon2 from "../../../Assets/Images/Rpm/Green.svg";
import { MdArrowOutward } from "react-icons/md";
import { FiSearch, FiX } from "react-icons/fi";
import { DatePicker, Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import PatientService from "../../../Services/PatientService";
import { setSelectedRpmPatient } from "../../../Redux/actions/rpmActions";
import { APP_ROUTES } from "../../../PageRouting/approutes";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { setCriticalityType } from "../../../Redux/actions/CriticalityActions";
import NoDataFound from "../../../Assets/Icons/NoDataCard2.svg";

function PatientMonitor() {
  const storedLoginResult = sessionStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;
  const [patients, setPatients] = useState([]);
  const dispatch = useDispatch();
  const history = useHistory();
  const selectedCategory = useSelector(
    (state) => state.criticality.criticalityType
  );
  const criticality = useSelector((state) => state.criticality.countObject);

  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    handleCriticalityChange(selectedCategory);
  }, []);

  const handleCriticalityChange = async (type = "0") => {
    setLoading(true);
    dispatch(setCriticalityType(type));
    try {
      let payload = {
        rpmApplicable: "Y",
        clinicalStatus: type,
        account_Id: loginResultObject.user.account_Id,
        user_clinic_Id: loginResultObject.user.clinic_Id,
      };
      let result = await PatientService.PatientListFilter(payload);
      setPatients(result?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const categoryMap = {
    0: { label: "Normal Patients", key: "Total_Normal_Patient_Count" },
    1: { label: "Abnormal Patients", key: "Total_Abnormal_Patient_Count" },
    2: { label: "Critical Patients", key: "Total_Critical_Patient_Count" },
  };

  const handlePatientPallette = (item) => {
    sessionStorage.setItem("rpmPatient", JSON.stringify(item));
    dispatch(setSelectedRpmPatient(item));
    history.push(APP_ROUTES.RPMPATIENTPALLETTE);
  };

  return (
    <Layouts>
      <div className="flex items-center justify-center gap-4 w-full mt-4">
        {/* <div className="flex flex-wrap justify-center items-center my-2">
          <div
            onClick={() => handleCriticalityChange("2")}
            className="flex items-center mx-3 bg-white rounded-3xl text-[#FF3022] text-sm border border-[#FF3022] pr-3 cursor-pointer"
          >
            <div className="bg-[#FF3022] py-1 px-3 mr-3 rounded-full">
              <img src={priorityIcon} width="20px" />
            </div>
            Critical Patients ({criticality?.Total_Critical_Patient_Count || 0})
          </div>

          <div
            onClick={() => handleCriticalityChange("1")}
            className="flex items-center mx-3 bg-white rounded-3xl text-[#FFA12C] text-sm border border-[#FFA12C] pr-3 cursor-pointer"
          >
            <div className="bg-[#FFA12C] py-1 px-3 mr-3 rounded-full">
              <img src={priorityIcon1} width="20px" />
            </div>
            Abnormal Patients ({criticality?.Total_Abnormal_Patient_Count || 0})
          </div>

          <div
            onClick={() => handleCriticalityChange("0")}
            className="flex items-center mx-3 bg-white rounded-3xl text-[#00B24B] text-sm border border-[#00B24B] pr-3 cursor-pointer"
          >
            <div className="bg-[#00B24B] py-1 px-3 mr-3 rounded-full">
              <img src={priorityIcon2} width="20px" />
            </div>
            Normal Patients ({criticality?.Total_Normal_Patient_Count || 0})
          </div>
        </div> */}
      </div>
      <div className="px-4 border rounded-md shadow-lg h-[550px] mt-6">
        <div className="flex justify-between items-center mt-3">
          <p className="text-lg font-sans font-semibold">
            {categoryMap[selectedCategory]?.label} (
            {criticality[categoryMap[selectedCategory]?.key] || 0})
          </p>
          <div className="flex gap-3 items-center">
            <span className="border rounded-full px-3 cursor-pointer py-1 text-sm font-sans font-semibold mt-1">
              Reviewed Patients
            </span>
            <div className="relative w-60">
              <input
                type="text"
                className="w-full border outline-none px-2 py-2 pr-10 rounded-md placeholder:text-xs"
                placeholder="Patient Search"
                onClick={showModal}
              />
              <FiSearch className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm" />
            </div>
          </div>
        </div>
        {loading ? (
          ""
        ) : (
          <div>
            {patients.length > 0 ? (
              <div className="overflow-x-auto bg-white rounded-md shadow mt-6">
                <table className="min-w-full text-sm text-gray-700">
                  <thead className="bg-green-50 text-left font-medium whitespace-nowrap">
                    <tr>
                      <th className="px-4 py-2">Name</th>
                      <th className="px-4 py-2">Patient ID</th>
                      <th className="px-4 py-2">Clinic</th>
                      <th className="px-4 py-2">Address</th>
                      <th className="px-4 py-2">Age</th>
                      <th className="px-4 py-2">Gender</th>
                      <th className="px-4 py-2">DOB</th>
                      <th className="px-4 py-2">Program</th>
                      <th className="px-4 py-2">Status</th>
                      <th className="px-4 py-2">View</th>
                    </tr>
                  </thead>
                  <tbody>
                    {patients.map((patient, index) => (
                      <tr key={index} className="border-t whitespace-nowrap">
                        <td className="px-4 py-4">
                          {patient.firstName + " " + patient?.lastName}
                        </td>
                        <td className="px-4 py-4">{patient.id}</td>
                        <td className="px-4 py-4">{patient.clinic_Name}</td>
                        <td className="px-4 py-4">{patient.address}</td>
                        <td className="px-4 py-4">{patient.age}</td>
                        <td className="px-4 py-4">
                          {patient.gender === "M"
                            ? "Male"
                            : patient.gender === "F"
                              ? "Female"
                              : patient.gender}
                        </td>
                        <td className="px-4 py-4">{patient.ageDob}</td>
                        <td className="px-4 py-4">{patient.program}</td>
                        <td className="px-4 py-4 capitalize">
                          {patient.status == "1" ? "Active" : "Inactive"}
                        </td>
                        <td className="px-4 py-4">
                          <div
                            onClick={() => handlePatientPallette(patient)}
                            className="w-7 h-7 border rounded-md flex items-center justify-center cursor-pointer bg-cyan-50"
                          >
                            <MdArrowOutward className="w-6 h-6 text-brand-primaryColor" />
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="flex justify-center items-center mt-6">
                <img src={NoDataFound} alt="No Data" className="h-[20rem]" />
              </div>
            )}
          </div>
        )}
        <div>
          <Modal
            title={
              <span className="text-lg font-sans font-semibold">
                Patient Search
              </span>
            }
            closable={{ "aria-label": "Custom Close Button" }}
            open={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            footer
            width={800}
          >
            <div>
              <div className="p-3">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Patient Code
                    </label>
                    <input
                      type="text"
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="Enter Patient Code"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      First Name
                    </label>
                    <input
                      type="text"
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="Enter First Name"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Last Name
                    </label>
                    <input
                      type="text"
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="Enter Last Name"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Date of Birth
                    </label>
                    <DatePicker className="w-full py-2" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Mobile Number
                    </label>
                    <input
                      type="tel"
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="Enter Mobile Number"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Email
                    </label>
                    <input
                      type="email"
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="Enter Email"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      UHID
                    </label>
                    <input
                      type="text"
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="Enter UHID"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Clinical Status
                    </label>
                    <input
                      type="text"
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="Enter Clinical Status"
                    />
                  </div>
                </div>
                <div className="mt-5">
                  <p className="text-base font-sans font-semibold">
                    Inactive Patients
                  </p>
                  <div className="flex justify-between">
                    <div className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        className="w-4 h-4 accent-blue-500"
                      />
                      <h4 className="text-sm font-sans font-semibold leading-none">
                        Inactive Patients
                      </h4>
                    </div>
                    <button className="px-2 py-1 text-white rounded-md">
                      Search
                    </button>
                  </div>
                </div>
                <div className="overflow-x-auto mt-5 scrollwidth">
                  <table className="min-w-full border border-gray-200 divide-y divide-gray-200 text-sm text-left font-sans">
                    <thead className="bg-gray-100 text-gray-700 font-semibold whitespace-nowrap">
                      <tr>
                        <th className="px-4 py-2">Patient ID</th>
                        <th className="px-4 py-2">First Name</th>
                        <th className="px-4 py-2">Last Name</th>
                        <th className="px-4 py-2">DOB</th>
                        <th className="px-4 py-2">Mobile No</th>
                        <th className="px-4 py-2">Email</th>
                        <th className="px-4 py-2">UHID</th>
                        <th className="px-4 py-2">Care Team</th>
                      </tr>
                    </thead>
                    <tbody className="bg-white text-gray-800">
                      {patients.map((patient, index) => (
                        <tr
                          key={index}
                          className="hover:bg-gray-50 whitespace-nowrap"
                        >
                          <td className="px-4 py-2">{patient.id}</td>
                          <td className="px-4 py-2">{patient.firstName}</td>
                          <td className="px-4 py-2">{patient.lastName}</td>
                          <td className="px-4 py-2">{patient.dob}</td>
                          <td className="px-4 py-2">{patient.mobile}</td>
                          <td className="px-4 py-2">{patient.email}</td>
                          <td className="px-4 py-2">{patient.uhid}</td>
                          <td className="px-4 py-2">{patient.careTeam}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="flex justify-end gap-2 mt-5">
                  <p className="border rounded-md border-brand-primaryColor text-brand-primaryColor px-3 py-1">
                    Cancel
                  </p>
                  <p className="border rounded-md bg-brand-primaryColor text-white px-3 py-1">
                    Submit
                  </p>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    </Layouts>
  );
}

export default PatientMonitor;
